import TelInputComponent from './TelInput'
import TelInputLGComponent from './TelInputLg'

export default {
	install(Vue, options) {
		Vue.component(TelInputComponent.name, TelInputComponent);
	}
}

export const TelInput = TelInputComponent;
export const TelInputLg = TelInputLGComponent;